//
// Console class
//
// Used to show a visual DevConsole over the game, so the developer can debug if needed
// To use, add the following:-
//
//   <script src="scripts/BPlib/DevConsole.js"></script>
//   DevConsole.initialise(consoleContainer);
//
// Console container is a PIXI container. This is used to add the DevConsole window to.

DevConsole = {};
DevConsole.startVisible = false;
DevConsole.debug = DevConsole.debug;
DevConsole.error = DevConsole.error;
DevConsole.info = DevConsole.info;
DevConsole.log = DevConsole.log;
DevConsole.warn = DevConsole.warn;

if (typeof PIXI.utils.skipHello === "function") {
  // Later versions of PIXI
  PIXI.utils.skipHello(); // Dont show PIXI startup message
} else {
  // Earlier versions of PIXI
  PIXI.utils._saidHello = true;
}

DevConsole.toggleShowConsole = function () {
  if (gdk !== undefined && gdk.isProductionBuild()) {
    return;
  }

  DevConsole.container.visible = !DevConsole.container.visible;
};

DevConsole.resize = function (width, height, isLandscape) {
  if (typeof DevConsole.graphics !== "undefined") {
    DevConsole.graphics.clear();
    DevConsole.graphics.beginFill(0x000000, 0.8);
    DevConsole.graphics.drawRect(0, 0, width, height);
    DevConsole.graphics.endFill();
  }
};

DevConsole.initialise = function (container) {
  systemOverlay.container = new PIXI.Container();
  DevConsole.container = new PIXI.Container();
  container.addChild(DevConsole.container);

  DevConsole.container.visible = DevConsole.startVisible;

  DevConsole.graphics = new PIXI.Graphics();
  DevConsole.container.addChild(DevConsole.graphics);

  DevConsole.text = "";
  DevConsole.textObject = new PIXI.Text(DevConsole.text, {
    fontfamily: "Roboto-Black",
    fontSize: 14,
    fill: 0xffffff,
    align: "left",
  });
  DevConsole.textObject.position.x = 10;
  DevConsole.textObject.position.y = 10;
  DevConsole.container.addChild(DevConsole.textObject);

  //DevConsole.clear = DevConsole.clear;
  DevConsole.addText("Reflex Console");
  DevConsole.addText("");

  /*
    if (Reflex.developerMode === true) {
        // List all properties
        for (var prop in bowser) {
            if (bowser.hasOwnProperty(prop)) {
                if (typeof(bowser[prop]) === "string" || typeof(bowser[prop]) === "number" || typeof(bowser[prop]) === "boolean") {
                    DevConsole.addText(prop + ": " + bowser[prop]);
                }
            }
        }
    }
    else {
        // Standard messages
        DevConsole.addText("Browser: " + bowser.name);
        DevConsole.addText("Version: " + bowser.version);
        if(systemData.renderer instanceof PIXI.CanvasRenderer) {
            DevConsole.addText("Renderer: Canvas");
        }
        else{
            DevConsole.addText("Renderer: WebGl");
        }
    }
    */

  DevConsole.addText("");
};

window.onerror = function (message, source, lineno, colno, error) {
  var index = source.lastIndexOf("/");
  var fileName = source.substr(index + 1);
  DevConsole.addText(
    message + "           - " + fileName + " (" + lineno + ")"
  );

  if (gdk === undefined || !gdk.isProductionBuild()) {
    if (DevConsole.container) {
      DevConsole.container.visible = true;
    }
  }
};

DevConsole.clear = function () {
  DevConsole.text = "";
  DevConsole.textObject.text = DevConsole.text;
};

DevConsole.addText = function (text) {
  DevConsole.text += "\r\n" + text;

  if (DevConsole.textObject !== undefined)
    DevConsole.textObject.text = DevConsole.text;
};

DevConsole._clear = DevConsole.clear;
DevConsole.clear = function () {
  DevConsole._clear();
  DevConsole.clear();
};

DevConsole.debug = function () {
  DevConsole.debug.apply(DevConsole, arguments);
  DevConsole.addText(arguments[0]);

  Reflex.logMessage("Debug", arguments[0]);
};
DevConsole.error = function () {
  DevConsole.error.apply(DevConsole, arguments);
  DevConsole.addText(arguments[0]);

  Reflex.logMessage("Error", arguments[0]);
};
DevConsole.info = function () {
  DevConsole.info.apply(DevConsole, arguments);
  DevConsole.addText(arguments[0]);

  Reflex.logMessage("Info", arguments[0]);
};
DevConsole.log = function () {
  DevConsole.log.apply(DevConsole, arguments);
  DevConsole.addText(arguments[0]);

  Reflex.logMessage("Log", arguments[0]);
};
DevConsole.warn = function () {
  DevConsole.warn.apply(DevConsole, arguments);
  DevConsole.addText(arguments[0]);

  Reflex.logMessage("Warning", arguments[0]);
};

Reflex.registerEventHandler("resize", DevConsole.resize);
